import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

class Loading extends React.Component {

	render() {
		return (
			this.props.loading && this.props.location == this.props.loading_location &&
			<div className={"loader text-center mb-3 mt-2 " + this.props.location}>
				<div className="badge badge-pill badge-secondary">
					<img src="/img/spinner.png" className="spinner anim-spin mb-0 mr-2" style={{ height: "20px !important" }} />
					<span style={{ fontSize: "small" }}>{__('Loading...')}</span>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return { loading: state.loading, loading_location: state.loading_location }
}

export default connect(mapStateToProps)(Loading);